import React, { useRef, useState } from 'react';
import Button from 'components/button';
import { useAsyncScript } from 'lib/hooks/useAsyncScript';
import { PERSONA_SCRIPT } from 'lib/constants';

const ContactSupport = () => {
  return (
    <>Please contact <a href="mailto:support@ledgerx.com">support@ledgerx.com</a></>
  )
}

export const PersonaVerification = ({ personaPayload, handleSubmit }) => {
  const [shouldContactSupport, setShouldContactSupport] = useState(false);
  const [didCancelInquiryEarly, setDidCancelInquiryEarly] = useState(false);
  const personaClientRef = useRef(null);

  const { isScriptLoaded } = useAsyncScript(PERSONA_SCRIPT);

  const onInquiryFinished = React.useCallback(
    async ({ inquiryId, status, fields }) => {
      if (status === 'failed') {
        return setShouldContactSupport(true);
      }
      handleSubmit(inquiryId);
    },
    [handleSubmit],
  );

  React.useEffect(() => {
    const environment =
      process.env.REACT_APP_API_BASE_URL === 'https://api.ledgerx.com'
        ? 'production'
        : 'sandbox';

    if (isScriptLoaded && personaPayload && !personaClientRef.current) {
      // personaPayload contains the template id OR an inquiry ID/session token pair (never both)
      personaClientRef.current = new window.Persona.Client({
        accountId: personaPayload.personaAccountId,
        templateId: personaPayload.personaTemplate,
        inquiryId: personaPayload.personaInquiryId,
        sessionToken: personaPayload.personaSessionToken,
        environment: environment,
        fields: personaPayload.prefill,
        onLoad: () => personaClientRef.current.open(),
        onComplete: onInquiryFinished,
        onCancel: () => setDidCancelInquiryEarly(true),
        onError: (err) => console.log('Inquiry flow error: ', err),
      });
    }
  }, [isScriptLoaded, personaPayload, onInquiryFinished]);

  if (!personaPayload) return null;

  if (shouldContactSupport) {
    return (
      <div style={{textAlign: 'center'}}>
        We had a problem verifying your application.
        <br/>
        <ContactSupport/>
      </div>
    )
  }

  return (
    <>
      {didCancelInquiryEarly && (
        <div style={{textAlign: 'center', marginBottom: '2rem'}}>
          Have a problem with your application?
          <br/>
          <ContactSupport/>
        </div>
      )}
      <Button
        secondary
        type="button"
        onClick={() => personaClientRef.current.open()}
      >
        Verify your identity
      </Button>
    </>
  );
};
